import React, {useEffect} from 'react'
import { Skeleton } from '@mui/material'

import { TitleWithPopover, AppTableSeeker } from "@components";
import { isLoadingCommonFilters } from "@signals";
import { CreateButton } from "../@components";
import { nameColumn, optionsColumn, executionsColumn, scopeColumn, enabledColumn } from "./columns";
import { useMonitoringAdminTableFilters } from "./@hooks";


export default function MonitoringAdminTable() {

    useEffect(() => {
        isLoadingCommonFilters.value = true
    },[])

    const { data, isLoading, isAdmin } = useMonitoringAdminTableFilters()

    if ( isLoading ) return <Skeleton variant="rectangular" height={500} />

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title="Monitoring Executions" />}
        columns={[
            nameColumn('name', 'Execution Name', true),
            scopeColumn(),
            executionsColumn(),
            ...isAdmin ? [...enabledColumn()] : [],
            ...isAdmin ? [optionsColumn()] : [],
        ]}
        options={{
            tableBodyHeight: '600',
            viewColumns: false,
            customToolbar: () => isAdmin && <CreateButton />
        }}
    />
}